import type { Product } from "../types/products";

export type SortOrder = "asc" | "desc";

/**
 * Returns a new array sorted by the given key and order.
 * Handles both number and string comparison.
 */
export function sortProducts(
  list: Product[],
  orderBy: keyof Product,
  order: SortOrder
): Product[] {
  return [...list].sort((a, b) => {
    const aValue = a[orderBy] ?? "";
    const bValue = b[orderBy] ?? "";
    if (typeof aValue === "number" && typeof bValue === "number") {
      return order === "asc" ? aValue - bValue : bValue - aValue;
    }
    return order === "asc"
      ? String(aValue).localeCompare(String(bValue))
      : String(bValue).localeCompare(String(aValue));
  });
}
